//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SectionMixin from '~/mixins/section'

export default {
  mixins: [
    SectionMixin
  ],
  props: {
    /**
     * Area page: diet | sex-drive | stress | energy | sleep
     */
    area: {
      type: String,
      required: true
    }
  },
  computed: {
    specifications () {
      return this.$t('nutritionalPlan.appSpecifications')
    }
  }
}
